import * as React from "react"
import { createFileRoute } from "@tanstack/react-router"

import { CommodityRate } from "@/types/meter"
import { Button } from "@/components/ui/button"
import {
  Credenza,
  CredenzaBody,
  CredenzaContent,
  CredenzaDescription,
  CredenzaHeader,
  CredenzaTitle,
  CredenzaTrigger,
} from "@/components/ui/credenza"
import {
  DialogClose,
  DialogContent,
  DialogFooter,
} from "@/components/ui/dialog"
import CommodityRateForm from "@/components/forms/commodity-rates"
import EditCommodityRatesForm from "@/components/forms/edit-connection-status"

export const Route = createFileRoute(
  "/_home/meter-connection-settings/commodity-rates/edit",
)({
  component: EditCommodityRatesPage,
})

export default function EditCommodityRatesPage({
  CommodityRatesData,
  setShowEditCommodityRatesModal,
}: {
  CommodityRatesData: CommodityRate
  setShowEditCommodityRatesModal: React.Dispatch<React.SetStateAction<boolean>>
}) {
  return (
    <main>
      <CredenzaContent className="flex w-full max-w-[850px] justify-center">
        <CredenzaBody>
          <CommodityRateForm
            editData={CommodityRatesData}
            setShowAddCommodityRateModal={setShowEditCommodityRatesModal}
          />
        </CredenzaBody>
      </CredenzaContent>
    </main>
  )
}
